import React from "react";
import {Link, NavLink, useNavigate} from "react-router-dom";
import IconMoon from "../img/icons/icon-moon.svg";
import IconSun from "../img/icons/icon-sun.svg";
import IconSearch from "../img/icons/icon-search.svg";
import IconNCSA from "../img/logo-ncsa.png";
import IconNCSAWhite from "../img/logo-ncsa-white.png";
import IconHTCR from "../img/logo-htcr.png";
import IconHTCRWhite from "../img/logo-htcr-white.png";
import {Config} from "../Config";

export default function Header(prop) {
    let navigate = useNavigate();

    let [lang, setLang] = React.useState('th');
    let urlSegment1 = window.location.pathname;

    let [newsCategory, setNewsCategory] = React.useState(null);

    React.useEffect(() => {

        let split = urlSegment1.split('/');
        let lang = split[1];
        if(lang === 'en') {
            setLang(lang);
        }

        (async function() {
            try {
                const newCategoryList = await getNewsCategory();
                setNewsCategory(newCategoryList);
            } catch (e) {
                //
            }
        })();

    }, []);

    function changeLang(selectLang) {
        let hostUrl = window.location.protocol + '//' + window.location.host;
        if(selectLang === 'en') {
            if(lang !== 'en') {
                window.location.href = hostUrl + '/en' + (urlSegment1 !== '/' ? urlSegment1:'');
            }
        }
        else {
            if(lang !== 'th') {
                window.location.href = hostUrl + urlSegment1.replace('/en', '');
            }
        }
    }

    async function getNewsCategory() {
        const response = await fetch(Config.apiUrl +'newsCategory/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <header className="header">
                <div className="container-fluid">
                    <div className="navbar-brand">
                        <a href={prop.lang === 'en' ? '/en/home':'/home'}>
                            <img className="logo-1" src={IconNCSA} alt="NCSA Logo" />
                            <img className="logo-2" src={IconHTCR} alt="HTCR Logo" />
                        </a>

                        <a href={prop.lang === 'en' ? '/en/home':'/home'}>
                            <img className="logo-1" src={IconNCSAWhite} alt="NCSA Logo" />
                            <img className="logo-2" src={IconHTCRWhite} alt="HTCR Logo" />
                        </a>
                    </div>

                    <ul className="nav nav-main">
                        <li className={urlSegment1 == '/home' || urlSegment1 == '/en/home' ? 'active':''}><a href={prop.lang === 'en' ? '/en/home':'/home'}><span className="line-animate">{prop.lang === 'en' ? 'Home':'หน้าหลัก'}</span></a>
                        </li>
                        <li className={"dropdown" + (urlSegment1.indexOf('about') > 0 || urlSegment1.indexOf('mission') > 0 || urlSegment1.indexOf('organization') > 0 || urlSegment1.indexOf('authority') > 0 || urlSegment1.indexOf('plan') > 0 ? ' active':'')}>
                            <a data-bs-toggle="dropdown" data-bs-display="static" href="#"><span
                                className="line-animate">{prop.lang === 'en' ? 'About HTCR':'เกี่ยวกับ ศชวซ.'}</span></a>
                            <ul className="dropdown-menu">
                                <li><a href={prop.lang === 'en' ? '/en/about':'/about'}>{prop.lang === 'en' ? 'About Us':'ประวัติความเป็นมา'}</a></li>
                                <li><a href={prop.lang === 'en' ? '/en/mission':'/mission'}>{prop.lang === 'en' ? 'Mission':'วิสัยทัศน์/พันธกิจ'}</a></li>
                                <li><a href={prop.lang === 'en' ? '/en/organization':'/organization'}>{prop.lang === 'en' ? 'Organization':'โครงสร้างคณะทำงาน ศชวซ.'}</a></li>
                                <li><a href={prop.lang === 'en' ? '/en/authority':'/authority'}>{prop.lang === 'en' ? 'Authority':'อำนาจหน้าที่'}</a></li>
                                <li><a href={prop.lang === 'en' ? '/en/plan':'/plan'}>{prop.lang === 'en' ? 'Plan':'แผนการดำเนินงาน'}</a></li>
                            </ul>

                        </li>

                        <li className={"dropdown" + (urlSegment1.indexOf('news') > 0 || urlSegment1.indexOf('announcement') > 0 || urlSegment1.indexOf('infographic') > 0 ? ' active':'')}>
                            <a data-bs-toggle="dropdown" data-bs-display="static" href="#"><span
                                className="line-animate">{prop.lang === 'en' ? 'News':'ข่าวสาร'}</span></a>
                            <ul className="dropdown-menu">
                                {
                                    newsCategory !== null && newsCategory.count > 0 ?
                                        <>
                                            {
                                                newsCategory.rows.map((row, index) => {
                                                    return (
                                                        <li key={index}><a href={prop.lang === 'en' ? '/en/news/category/' + row.slug:'/news/category/' + row.slug}>{prop.lang === 'en' ? row.title_en:row.title}</a></li>
                                                    )
                                                })
                                            }
                                        </> : ''
                                }
                                <li><a href={prop.lang === 'en' ? '/en/announcement':'/announcement'}>{prop.lang === 'en' ? 'Announcement':'ประกาศ ศชวซ.'}</a></li>
                                <li><a href={prop.lang === 'en' ? '/en/infographic':'/infographic'}>{prop.lang === 'en' ? 'Infographic':'Infographic'}</a></li>
                            </ul>
                        </li>

                        <li className={"dropdown" + (urlSegment1.indexOf('experts') > 0 ? ' active':'')}>
                            <a data-bs-toggle="dropdown" data-bs-display="static" href="#"><span
                                className="line-animate">{prop.lang === 'en' ? 'Experts':'ผู้เชี่ยวชาญ'}</span></a>
                            <ul className="dropdown-menu">
                                <li><a href={prop.lang === 'en' ? '/en/experts':'/experts'}>{prop.lang === 'en' ? 'Experts List':'รายชื่อผู้เชี่ยวชาญ'}</a></li>
                                <li><a href={prop.lang === 'en' ? '/en/experts_report':'/experts_report'}>{prop.lang === 'en' ? 'Experts Report':'สถิติที่เกี่ยวข้อง'}</a></li>
                            </ul>
                        </li>

                        <li className={"dropdown" + (urlSegment1.indexOf('operating_results') > 0 || urlSegment1.indexOf('member_results') > 0 ? ' active':'')}>
                            <a data-bs-toggle="dropdown" data-bs-display="static" href="#"><span
                                className="line-animate">{prop.lang === 'en' ? 'Publication documents':'เอกสารเผยแพร่'}</span></a>
                            <ul className="dropdown-menu">
                                <li><a href={prop.lang === 'en' ? '/en/operating_results':'/operating_results'}>{prop.lang === 'en' ? 'Operating Results':'ผลการดำเนินงานของ ศชวซ.'}</a></li>
                                <li><a href={prop.lang === 'en' ? '/en/member_results':'/member_results'}>{prop.lang === 'en' ? 'Member Results':'ผลการดำเนินงานของสมาชิก'}</a></li>
                            </ul>
                        </li>

                        <li className={urlSegment1.indexOf('partners') > 0 ? 'active':''}><a href={prop.lang === 'en' ? '/en/partners':'/partners'}><span className="line-animate">{prop.lang === 'en' ? 'Partners':'หน่วยงานเครือข่าย'}</span></a></li>
                        <li className={urlSegment1.indexOf('contact') > 0 ? 'active':''}><a href={prop.lang === 'en' ? '/en/contact':'/contact'}><span className="line-animate">{prop.lang === 'en' ? 'Contact Us':'ติดต่อเรา'}</span></a></li>
                        <li className={urlSegment1.indexOf('sitemap') > 0 ? 'active':''}><a href={prop.lang === 'en' ? '/en/sitemap':'/sitemap'}><span className="line-animate">{prop.lang === 'en' ? 'Site Map':'แผนผังเว็บไซต์'}</span></a></li>
                    </ul>

                    <ul className="nav nav-genaral">
                        <li className="d-none">
                            <a className="btn btn-trans" href="#">
                                <img className="svg-js icons" src={IconSearch} alt="" />
                            </a>
                        </li>
                        <li>
                            <button className="btn btn-trans btn-theme-toggle" type="button">
                                <img className="svg-js icons moon" src={IconMoon} alt="" />
                                <img className="svg-js icons sun" src={IconSun} alt="" />
                            </button>
                        </li>
                        <li className="lang">
                            <a className={lang.toUpperCase() === 'TH' ? 'active':''} href="#" onClick={e => changeLang('th')}>TH</a>
                            <span className="vr"></span>
                            <a className={lang.toUpperCase() === 'EN' ? 'active':''} href="#" onClick={e => changeLang('en')}>EN</a>
                        </li>

                        <li>
                            <button className="btn btn-icon navbar-toggle" type="button">
                            <span className="group">
                                <span></span>
                                <span></span>
                                <span></span>
                            </span>
                            </button>
                        </li>
                    </ul>
                </div>
            </header>

            <div className="navbar-slider">
                <ul className="nav nav-main mainmenu">
                    <li><a href={prop.lang === 'en' ? '/en':'/'}>{prop.lang === 'en' ? 'Home':'หน้าหลัก'}</a></li>
                    <li className="dropdown level-1">
                        <a href="#" data-bs-toggle="dropdown" data-bs-display="static">{prop.lang === 'en' ? 'About HTCR':'เกี่ยวกับ ศชวซ.'}</a>
                        <ul className="dropdown-menu">
                            <li className="nav-title"><span className="arrow"></span> {prop.lang === 'en' ? 'About HTCR':'เกี่ยวกับ ศชวซ.'}</li>
                            <li><a href={prop.lang === 'en' ? '/en/about':'/about'}>{prop.lang === 'en' ? 'About Us':'ประวัติความเป็นมา'}</a></li>
                            <li><a href={prop.lang === 'en' ? '/en/mission':'/mission'}>{prop.lang === 'en' ? 'Mission':'วิสัยทัศน์/พันธกิจ'}</a></li>
                            <li><a href={prop.lang === 'en' ? '/en/organization':'/organization'}>{prop.lang === 'en' ? 'Organization':'โครงสร้างคณะทำงาน ศชวซ.'}</a></li>
                            <li><a href={prop.lang === 'en' ? '/en/authority':'/authority'}>{prop.lang === 'en' ? 'Authority':'อำนาจหน้าที่'}</a></li>
                            <li><a href={prop.lang === 'en' ? '/en/plan':'/plan'}>{prop.lang === 'en' ? 'Plan':'แผนการดำเนินงาน'}</a></li>
                        </ul>
                    </li>
                    <li className="dropdown level-1">
                        <a href="#" data-bs-toggle="dropdown" data-bs-display="static">{prop.lang === 'en' ? 'News':'ข่าวสาร'}</a>
                        <ul className="dropdown-menu">
                            <li className="nav-title"><span className="arrow"></span> {prop.lang === 'en' ? 'News':'ข่าวสาร'}</li>
                            {
                                newsCategory !== null && newsCategory.count > 0 ?
                                    <>
                                        {
                                            newsCategory.rows.map((row, index) => {
                                                return (
                                                    <li key={index}><a href={prop.lang === 'en' ? '/en/news/category/' + row.slug:'/news/category/' + row.slug}>{prop.lang === 'en' ? row.title_en:row.title}</a></li>
                                                )
                                            })
                                        }
                                    </> : ''
                            }
                            <li><a href={prop.lang === 'en' ? '/en/announcement':'/announcement'}>{prop.lang === 'en' ? 'Announcement':'ประกาศ ศชวซ.'}</a></li>
                            <li><a href={prop.lang === 'en' ? '/en/infographic':'/infographic'}>{prop.lang === 'en' ? 'Infographic':'Infographic'}</a></li>
                        </ul>
                    </li>
                    <li className="dropdown level-1">
                        <a href="#" data-bs-toggle="dropdown" data-bs-display="static">{prop.lang === 'en' ? 'Experts':'ผู้เชี่ยวชาญ'}</a>
                        <ul className="dropdown-menu">
                            <li className="nav-title"><span className="arrow"></span> {prop.lang === 'en' ? 'Experts':'ผู้เชี่ยวชาญ'}</li>
                            <li><a href={prop.lang === 'en' ? '/en/experts':'/experts'}>{prop.lang === 'en' ? 'Experts List':'รายชื่อผู้เชี่ยวชาญ'}</a></li>
                            <li><a href={prop.lang === 'en' ? '/en/experts_report':'/experts_report'}>{prop.lang === 'en' ? 'Experts Report':'สถิติที่เกี่ยวข้อง'}</a></li>
                        </ul>
                    </li>
                    <li className="dropdown level-1">
                        <a href="#" data-bs-toggle="dropdown" data-bs-display="static">{prop.lang === 'en' ? 'Publication documents':'เอกสารเผยแพร่'}</a>
                        <ul className="dropdown-menu">
                            <li className="nav-title"><span className="arrow"></span> {prop.lang === 'en' ? 'Publication documents':'เอกสารเผยแพร่'}</li>
                            <li><a href={prop.lang === 'en' ? '/en/operating_results':'/operating_results'}>{prop.lang === 'en' ? 'Operating Results':'ผลการดำเนินงานของ ศชวซ.'}</a></li>
                            <li><a href={prop.lang === 'en' ? '/en/member_results':'/member_results'}>{prop.lang === 'en' ? 'Member Results':'ผลการดำเนินงานของสมาชิก'}</a></li>
                        </ul>
                    </li>
                    <li><a href={prop.lang === 'en' ? '/en/partners':'/partners'}><span className="line-animate">{prop.lang === 'en' ? 'Partners':'หน่วยงานเครือข่าย'}</span></a></li>
                    <li><a href={prop.lang === 'en' ? '/en/contact':'/contact'}><span className="line-animate">{prop.lang === 'en' ? 'Contact Us':'ติดต่อเรา'}</span></a></li>
                    <li><a href={prop.lang === 'en' ? '/en/sitemap':'/sitemap'}><span className="line-animate">{prop.lang === 'en' ? 'Site Map':'แผนผังเว็บไซต์'}</span></a></li>
                </ul>

                <div className="lang">
                    <h6>{prop.lang === 'en' ? 'Language':'ภาษา'}</h6>
                    <a className={lang.toUpperCase() === 'TH' ? 'active':''} href="#" onClick={e => changeLang('th')}>TH</a> | <a className={lang.toUpperCase() === 'EN' ? 'active':''} href="#" onClick={e => changeLang('en')}>EN</a>
                </div>
            </div>
        </>
    );
} 